import {readFileDataAsText} from "../util/ImageUtil";

export class BlobBuilder {
    private readonly encoder: TextEncoder;
    private readonly parts: Uint8Array[] = [];

    constructor() {
        this.encoder = new TextEncoder();
    }

    append(data: string | undefined) {
        if (!data) {
            return;
        }

        this.parts.push(this.encoder.encode(data));
    }

    copyTo(target: BlobBuilder) {
        target.parts.push(...this.parts);
    }

    public convertToString(): Promise<string> {
        const blob = new Blob(this.parts);
        if (!blob.text) {
            return readFileDataAsText(blob);
        }
        return blob.text();
    }
}
